import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, FloatingLabel, Form, Image, InputGroup } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Email from '../domain/Email.js';
import Birthday from '../domain/Birthday.ts';
import Password from '../domain/Password.js';
import Sex from '../domain/Sex.js';
import ApiFetch from './ApiFetch.js';
import Category from './Category.js';
import Dialog from './Dialog.js';
import FavoriteIcon from './FavoriteIcon.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import { useTranslation } from "react-i18next";
import UserName from '../domain/UserName.js';
import LoadingButton from '@mui/lab/LoadingButton';

const RegistConfirm = () => {
	async function getRegistSession(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/session").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function oneTimePasswordSend(email){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/onetime/regist",{email:email})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function regist(type,email,userName,sex,birthday,password,passwordConfirm,onetimePassword){
        let emailObj = new Email(email)
        let userNameObj = new UserName(userName)
        let sexObj = new Sex(sex)
        let birthdayObj = new Birthday(birthday)
        let passwordObj = new Password(password)
        let passwordConfirmObj = new Password(passwordConfirm)
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if(!emailObj.validate(dialog,true) || !userNameObj.validate(dialog,true) || !sexObj.validate(dialog,true) || !birthdayObj.validate(dialog,true)
            || !passwordObj.validate(dialog,true) || !passwordConfirmObj.validate(dialog,true)){
            return false
        }
        // メールアドレスがTwitetrに紐づいていない場合のみチェック必須
        if(session.email === ""){
            if(!onetimePasswordObj.validate(dialog,true)){
                return false
            }
        }
        if(password !== passwordConfirm){
            dialog("エラー","ログインパスワードとログインパスワード再入力が異なります。")
            return false
        }
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/"+type,{email:email,userName:userName,sex:sex,birthday:birthday,password:password,onetimePassword:onetimePassword}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    window.location.href = "/"
                } else {
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    const {t,i18n} = useTranslation()
    // ナビゲート
    const navigate = useNavigate();

    const location = useLocation()

	const [info,setInfo] = useState("")
    const [session,setSession] = useState([])
    const [authType,setAuthType] = useState("")
    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)
    const [loading,setLoading] = useState(false)

    const [readTerms,setReadTerms] = useState(false)
    const [readGuideline,setReadGuideline] = useState(false)
    const [readPrivacyPolicy,setReadPrivacyPolicy] = useState(false)

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

	useEffect(() => {
		document.querySelector("title").textContent = t("regist.signupWithSNSAccount") + " - アワートAI"
        if(location.search.indexOf("autherror") !== -1){
            setInfo("認証に失敗しました。")
        }
        getRegistSession().then(json => {
            if(json.result){
                setSession(json.data)
                setAuthType(json.data.authType)
            }
        })
	},[location.pathname,i18n.language])

    return(
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{width:"360px"}}>
            <Container>
                <h3>{t("regist.signupWithSNSAccount")}</h3>
                <p>{info}</p>
                <FloatingLabel controlId="email" label={t("setting.account.email")+" ("+t("common.required")+")"} className="mb-3">
                    <Form.Control type="email" defaultValue={session.email} readOnly={session.email !== ""} />
                </FloatingLabel>
                <FloatingLabel controlId="password" label={t("setting.account.password")+" ("+t("common.required")+")"} className="mb-3">
                    <Form.Control type="password" placeholder="" autoComplete="new-password" />
                </FloatingLabel>
                <FloatingLabel controlId="password-confirm" label={t("setting.account.password")+" ("+t("common.confirm")+")"} className="mb-3">
                    <Form.Control type="password" placeholder="" />
                </FloatingLabel>
                <p>{t("setting.passwordReset.characterString")}</p>
                <FloatingLabel controlId="name" label="ユーザ名" className="mb-3">
                    <Form.Control type="text" cows="10" defaultValue={session.userName} />
                </FloatingLabel>
                <p className='d-inline '>{t("setting.account.sex")} <span style={{fontSize:"12px",color:"#555555"}}>({t("common.required")}、{t("common.private")})</span></p>
                <Form.Select id="sex" className="mb-3">
                    <option></option>
                    <option value="1">{t("setting.account.male")}</option>
                    <option value="2">{t("setting.account.female")}</option>
                </Form.Select>
                <FloatingLabel controlId="birthday" label={t("setting.account.birthday")+" ("+t("common.required")+"、"+t("common.private")+")"} className="mb-3">
                    <Form.Control type="date" />
                </FloatingLabel>
                <Button onClick={() => {
                if(new Email(document.getElementById("email").value).validate(dialog,true)){
                    dialog("確認",t("common.onetimePasswordSentMessage"))
                    oneTimePasswordSend(document.getElementById("email").value)
                    setOneTimePasswordSended(true)
                }
                }} className="mb-1" style={{display:session.email === "" ? "block" : "none"}}>{t("setting.passwordReset.sendOnetimePassword")}</Button>
                <div className="mb-3" style={{display:session.email === "" ? "block" : "none"}}>{t("setting.passwordReset.sendMessage")}</div>
                <FloatingLabel controlId="onetime-password" label={t("common.onetimePassword")} style={{display:oneTimePasswordSended?"block":"none"}}>
                    <Form.Control type="number" cows="10" />
                </FloatingLabel>
                <FloatingLabel controlId="referrer-user-name" label={t("common.referrerUserName")}>
                    <Form.Control type="text" value={session.referrerUserName} disabled />
                </FloatingLabel><br />
                <Button variant='outline-primary'
                onClick={() => {
                    dialog("招待制度について",
                    <Container>
                        利用者の招待を受けて登録することで、<br />
                        招待した人、招待された人の両者に特典が付与される制度です。<br /><br />
                        2段階に分けて特典が付与されます。<br /><br />
                        ①招待を受けてユーザー登録後にSMS認証することで、両者に2000ポイント<br />
                        ②招待された利用者が、10投稿以上行うことで、両者に3000ポイント<br /><br />
                        ■招待するために必要なこと<br />
                        ・招待する側<br />
                        招待する利用者はSMS認証完了することで、マイページの招待ボタンがクリックできるようになります。<br />
                        ・招待される側<br />
                        招待者のマイページにある「招待を受けて登録」ボタンから登録します。
                    </Container>
                    )
                }}>招待制度について</Button>
                <br /><br />
                <Link to={"/terms"} target="_blank">{t("common.termsOfService")}</Link><br />
                <Link to={"/guideline"} target="_blank">{t("common.guideline")}</Link><br />
                <Link to={"/privacy"} target="_blank">{t("common.privacyPolicy")}</Link><br />
                <br />
                <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-terms">
                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                        setReadTerms(e.currentTarget.checked)
                    }} />
                    <Form.Control type="text" value={t("common.checkedTerms")} readOnly />
                </InputGroup>
                <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-guideline">
                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                        setReadGuideline(e.currentTarget.checked)
                    }} />
                    <Form.Control type="text" value={t("common.checkedGuideline")} readOnly />
                </InputGroup>
                <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-privacy-policy">
                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                        setReadPrivacyPolicy(e.currentTarget.checked)
                    }} />
                    <Form.Control type="text" value={t("common.checkedPrivacyPolicy")} readOnly />
                </InputGroup>
                <LoadingButton loading={loading} variant='contained' onClick={() => {
                if(!readTerms || !readGuideline || !readPrivacyPolicy){
                    dialog(t("common.confirm"),t("common.pleaseCheckAll"))
                    return
                }
                setLoading(true)
                regist(
                    authType,
                    document.getElementById("email").value,
                    document.getElementById("name").value,
                    document.getElementById("sex").value,
                    document.getElementById("birthday").value,
                    document.getElementById("password").value,
                    document.getElementById("password-confirm").value,
                    document.getElementById("onetime-password").value
                ).then(r => {
                    if(!r) setLoading(false)
                })
                }} className="mt-3" disabled={!readTerms || !readGuideline || !readPrivacyPolicy}>{t("common.agreeToTheTerms")}</LoadingButton>
                <p className='mt-3'>※捨てアドレスなど不確定なメールアドレスでの登録はできません。使用した場合はアカウントが停止され、今後アカウントの作成は行えなくなります。</p>
            </Container>
        </Container>
        <Footer />
    </div>
    )
}

export default RegistConfirm;
